export default __webpack_public_path__ + "static/bookATour-69e3ab4dd70709f7682e49e795d73415.jpg";